var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullhorn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 33,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 2,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 13.707c0-2.912 2.558-5.14 5.47-5.155 1.276-.007 2.548-.092 3.53-.328 3.287-.79 7-4.112 7-4.112v19.19s-3.713-3.323-7-4.113c-.982-.235-2.254-.32-3.53-.328C4.558 18.846 2 16.618 2 13.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.56v9.178c0 1.07-1.456 1.392-1.907.421L6 19.189M18 17.819c1.657 0 3-1.841 3-4.112s-1.343-4.112-3-4.112"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v32.896H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullhorn);
export default __webpack_public_path__ + "static/media/bullhorn.a50b14abb33a17c65214b3d4626fc854.svg";
export { ForwardRef as ReactComponent };